/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { EntityId } from '../../types/api/EntityId';

export enum CreateServiceActions {
  OPEN_CREATE_SERVICE_OVERLAY = 'OPEN_CREATE_SERVICE_OVERLAY',
  CLOSE_CREATE_SERVICE_OVERLAY = 'CLOSE_CREATE_SERVICE_OVERLAY',
}

export type CreateServiceState = {
  isOpen: boolean;
  organizationId?: EntityId;
  projectId?: EntityId;
  clusterId?: EntityId;
};

export type OpenCreateServiceOverlayAction = {
  type: CreateServiceActions.OPEN_CREATE_SERVICE_OVERLAY;
  payload: {
    organizationId?: EntityId;
    projectId?: EntityId;
    clusterId?: EntityId;
  };
};

export type CloseCreateServiceOverlayAction = {
  type: CreateServiceActions.CLOSE_CREATE_SERVICE_OVERLAY;
};

export type CreateServiceActionTypes = OpenCreateServiceOverlayAction | CloseCreateServiceOverlayAction;
